import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'

import { DateRangePicker, Select } from '../../../core/components'
import { Button, Panel } from '../../../core/components/styled'

import { menuPublicationAgeReportSchema } from './schemas'

const MenuPublicationAgeReportForm = ({
  isGeneratingReport,
  menuTypeOptions,
  onSubmit,
}) => {
  const formMethods = useForm({
    defaultValues: {
      dateRange: '',
      menuType: '',
    },
    resolver: yupResolver(menuPublicationAgeReportSchema),
  })

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Panel withBorderBottom>
          <Row type="flex" align="bottom">
            <Col span={5}>
              <Select
                name="menuType"
                label="Menu type"
                options={menuTypeOptions}
                showSearch
                allowClear
              />
            </Col>
            <Col span={5} offset={1}>
              <DateRangePicker name="dateRange" label="Date range" />
            </Col>
            <Col span={2} offset={1}>
              <Button
                style={{ marginBottom: '24px' }}
                type="primary"
                htmlType="submit"
                loading={isGeneratingReport}
              >
                Generate
              </Button>
            </Col>
          </Row>
        </Panel>
      </form>
    </FormProvider>
  )
}

MenuPublicationAgeReportForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isGeneratingReport: PropTypes.bool.isRequired,
  menuTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default MenuPublicationAgeReportForm
